import React from 'react'

import GroupWrapper from '../../dashboard/components/GroupWrapper'
import Flex from '../../../../components/layouts/Flex'
import RecruiterUsageReport from './RecruiterUsageReport'
import ApplicantUsageReport from './ApplicantUsageReport'
import CountryCityBarChart from './CountryCityBarChart'

const Charts = () => {
    return (
        <GroupWrapper title="Success Rate Charts">
            <Flex
                width="100%"
                direction="column"
                height="65vh"
                padding="1rem"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <RecruiterUsageReport />
            </Flex>
            <Flex
                width="100%"
                direction="column"
                height="65vh"
                padding="1rem"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <ApplicantUsageReport />
            </Flex>
            <Flex
                width="100%"
                direction="column"
                height="65vh"
                padding="1rem"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <CountryCityBarChart />
            </Flex>
        </GroupWrapper>
    )
}

export default Charts